import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import IndexMenu from "./IndexMenu";
import { getReadStatusColor } from "../../../../constants/colors";
import StatusChip from "../StatusChip";

/**
 * カード上部の見出し部分（NEW/閲覧済みバッジ + メニュー + タイトル）
 */

const IndexCardHeader = ({
  title,
  isNew,
  itemId,
  type,
  contractExists,
  isActive,
}) => {
  const theme = useTheme();

  // 未読＝黒、既読＝薄いグレー
  const textColor = getReadStatusColor(theme, isNew);

  return (
    <Box>
      {/* 上段：NEW（左） / メニュー（右） */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 0.5,
        }}
      >
        <StatusChip isNew={isNew} type={type} />

        <IndexMenu
          itemId={itemId}
          type={type}
          contractExists={contractExists}
          isActive={isActive}
        />
      </Box>

      {/* 下段：タイトル */}
      <Typography
        variant="subtitle1"
        sx={{
          m: 0,
          fontWeight: "bold",
          fontSize: { xs: "0.8rem", sm: "0.9rem" },
          lineHeight: 1.4,
          color: textColor,
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default IndexCardHeader;
